import { render } from "./PlaylistDetails.vue?vue&type=template&id=25bb19f8"
import script from "./PlaylistDetails.vue?vue&type=script&lang=js"
export * from "./PlaylistDetails.vue?vue&type=script&lang=js"

import "./PlaylistDetails.vue?vue&type=style&index=0&id=25bb19f8&lang=css"
script.render = render

export default script